import * as Sentry from '@sentry/react';
import ReactDOM from 'react-dom/client';

import App from './App.jsx';
import './index.css';

// Known third-party/extension error patterns
const thirdPartyPatterns = [
  'runtime.sendMessage',
  'chrome-extension',
  'Tab not found',
  'fbq', // Facebook Pixel
  'gtag', // Google Analytics
  'googletagmanager',
  'google-analytics',
  'connect.facebook.net',
  'enableButtonsClickedMetaDataLogging', // Facebook in-app browser
  'Java object is gone', // Facebook in-app browser
  'webkit.messageHandlers', // Facebook in-app browser / iOS webkit
  'The object does not support the operation or argument', // Facebook in-app browser / InvalidAccessError
];

Sentry.init({
  dsn: import.meta.env.DEV ? '' : import.meta.env.VITE_SENTRY_DSN,
  integrations: [
    Sentry.browserTracingIntegration(),
    Sentry.replayIntegration(),
    Sentry.captureConsoleIntegration({
      levels: ['error'],
    }),
  ],
  // Performance Monitoring
  tracesSampleRate: 1.0, //  Capture 100% of the transactions
  // Set 'tracePropagationTargets' to control for which URLs distributed tracing should be enabled
  tracePropagationTargets: ['localhost', /^https:\/\/api\.lanetalk\.com\/v1/],
  // Session Replay
  replaysSessionSampleRate: 0.1, // Sample at 10% in production.
  replaysOnErrorSampleRate: 1.0, // If you're not already sampling the entire session, change the sample rate to 100% when sampling sessions where errors occur.
  beforeSend(event, hint) {
    // Check error message
    const error = hint?.originalException;
    if (
      error &&
      typeof error.message === 'string' &&
      thirdPartyPatterns.some((pattern) => error.message.includes(pattern))
    ) {
      return null;
    }
    // Check exception values
    if (
      event.exception &&
      event.exception.values &&
      event.exception.values.some(
        (ex) =>
          ex.value &&
          thirdPartyPatterns.some((pattern) => ex.value.includes(pattern))
      )
    ) {
      return null;
    }
    // Check stacktrace for third-party scripts
    if (
      event.exception &&
      event.exception.values &&
      event.exception.values.some(
        (ex) =>
          ex.stacktrace &&
          ex.stacktrace.frames &&
          ex.stacktrace.frames.some(
            (frame) =>
              frame.filename &&
              thirdPartyPatterns.some((pattern) =>
                frame.filename.includes(pattern)
              )
          )
      )
    ) {
      return null;
    }
    // Check if error originated from a known third-party script in index.html
    if (
      event.request &&
      event.request.url &&
      thirdPartyPatterns.some((pattern) => event.request.url.includes(pattern))
    ) {
      return null;
    }
    return event;
  },
});

ReactDOM.createRoot(document.getElementById('root')).render(<App />);
